import registerModule from './register.module';
export default registerModule;
